import { Translate } from '~/i18n';
import Container from '~/components/common/container';

import style from './style.module.css';

const Partners = () => {
   return (
      <div className={`${style['gray-bg']}`}>
         <Container className="grid justify-items-center  px-2 pb-[30px] lg:pb-[95px]  ">
            <div className="text-[30px] lg:text-[50px] lg:pt-[40px] py-[20px] lg:py-[95px] text-center font-bold ">
               <Translate id="business:network" />
            </div>
            <div className="lg:hidden">
               <img src="/images/ticketing/map-mobile.png" className="w-full" />
               <div className="bg-jarir-primary text-white py-[32px] px-[27px] rounded-b-xl">
                  <div className="text-[30px] pb-[21px] leading-[35px] font-semibold">
                     <Translate id="business:partnership" />
                  </div>
                  <div className="text-[18px] pb-[21px]  ">
                     <Translate id="business:hala yalla and jarir" />
                  </div>
                  <hr />
                  <div className="grid grid-cols-2 gap-3 pt-[20px]">
                     <div>
                        <div className="text-[30px] font-semibold">1m+</div>
                        <div className="text-[16px]">
                           <Translate id="business:daily website visits" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[30px] font-semibold ltr:text-center">10+</div>
                        <div className="text-[16px] ltr:text-center">
                           <Translate id="business:customers" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[30px] font-semibold">50+</div>
                        <div className="text-[16px] ltr:whitespace-nowrap">
                           <Translate id="business:gcc" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="hidden lg:flex h-[867px]">
               <div className="bg-jarir-primary text-white pt-[67px] px-[40px] ltr:rounded-l-xl  rtl:rounded-r-xl">
                  <div className="text-[40px] xl:text-[50px] pb-[45px] leading-[63px] font-semibold">
                     <Translate id="business:partnership" />
                  </div>
                  <div className="text-[18px] xl:text-[23px] pb-[45px] ">
                     <Translate id="business:hala yalla and jarir" />
                  </div>
                  <hr />
                  <div className="grid grid-cols-3 gap-3 pt-[40px]">
                     <div>
                        <div className="text-[34px] font-semibold">1m+</div>
                        <div>
                           <Translate id="business:daily website visits" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[34px] font-semibold">10m+</div>
                        <div>
                           <Translate id="business:customers" />
                        </div>
                     </div>
                     <div>
                        <div className="text-[34px] font-semibold">50+</div>
                        <div>
                           <Translate id="business:gcc" />
                        </div>
                     </div>
                  </div>
               </div>
               <img src="/images/ticketing/jarir-map.png" className="lg:w-7/12 rtl:rounded-l-3xl" />
            </div>
         </Container>
      </div>
   );
};
export default Partners;
